angular.module('taric.referenceDate', [])
    .component('referenceDatePicker', require('./components/reference-date-picker'))
    .factory('referenceDateService', require('./services/reference-date'))
    ;
